import { useState } from 'react';
import { startPasswordReset } from '@/core/auth';
import { config } from '@/core/config';
import { Button } from '@/core/ui';
import { EnvelopeSimple } from '@/core/ui/icons';

/**
 * Conteúdo do "Esqueceu a senha?".
 *
 * Com `VITE_PASSWORD_RESET_EMAIL` ligado (SMTP do Keycloak configurado), o
 * botão leva à tela "Redefinir senha" do Keycloak: ele manda o link por
 * e-mail e, depois da nova senha, devolve a pessoa logada para cá. Desligado,
 * a senha continua sendo redefinida pela empresa.
 */
export function ForgotPassword({
  getUsername,
  returnTo,
}: {
  /** Lido no clique: o que já estiver digitado em "Usuário ou e-mail" vem preenchido lá. */
  getUsername: () => string;
  returnTo?: string;
}) {
  const [pending, setPending] = useState(false);
  const [failed, setFailed] = useState(false);

  if (!config.auth.passwordResetByEmail) {
    return (
      <p className="rounded-xl bg-surface-2 px-3 py-2 text-xs leading-relaxed text-fg-muted">
        A senha é redefinida pela sua empresa. Fale com o RH ou com o administrador da plataforma.
      </p>
    );
  }

  async function start() {
    setFailed(false);
    setPending(true);
    try {
      await startPasswordReset(getUsername(), returnTo);
    } catch {
      setPending(false);
      setFailed(true);
    }
  }

  return (
    <div className="rounded-xl bg-surface-2 px-3 py-3 text-xs leading-relaxed text-fg-muted">
      <p>
        Enviamos um link para o e-mail da sua conta. Por ele você cria uma nova senha e volta direto para o
        CentralOne.
      </p>
      <Button size="sm" className="mt-3 rounded-full" loading={pending} onClick={() => void start()}>
        {!pending && <EnvelopeSimple aria-hidden className="size-4" />}
        Redefinir por e-mail
      </Button>
      {failed && (
        <p role="alert" className="mt-2 text-red-400 light:text-red-600">
          Não foi possível abrir a redefinição agora. Tente novamente.
        </p>
      )}
    </div>
  );
}
